import MemberComponent from '@components/member';
import * as React from 'react';

export interface IMemberpageProps {}

export default function Memberpage(props: IMemberpageProps) {
  return <MemberComponent />;
}
